import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

	instance: string = "rfhapp";
	liberty: boolean = false;
	variant: string = "";
	cugc: boolean = false;
	iapPrefix: string = "prllxapp_";
	special2: boolean = true;
	feed: boolean = true;

	tomaiUrl: string = "";
	//botaiUrl: string = "https://tomai.herokuapp.com/api";
	//botaiUrl: string = "localhost:3000/api";
	botaiUrl: string = "https://inajar-00bba6520274.herokuapp.com/api"; // TBD use this one
	hasTom: boolean = false;
	hasBarb: boolean = true;
	hasDomi: boolean = false;
	chrisaiToken: string = '';
	hasChris: boolean = false;

	nativeAudio: boolean = false;

  	constructor() {}
}